import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { commonState } from "../../store";
import { CapacityContainer as CapacityContainer } from "../UsageBased_Capacity";
import { BillingSummaryByOfficeContainer } from "./BillingSummaryByOffice";
import { State } from "./store";

export interface Props {
    state: State;
    common: commonState;
}

export const BasePaymentsRouter: React.FC<Props> = (props: Props) => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/summary`}>
                <BillingSummaryByOfficeContainer
                    state={props.state}
                    commonState={props.common}
                />
            </Route>
        </Switch>
    );
};
